import { render, staticRenderFns } from "./TheChangePassordByExpirationModal.vue?vue&type=template&id=3ef9a381"
import script from "./TheChangePassordByExpirationModal.vue?vue&type=script&lang=js"
export * from "./TheChangePassordByExpirationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports